import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { ArrowLeft, Search } from 'lucide-react';
import { Suspense } from 'react';

import { ExecutionExplorer } from '@/components/execution-explorer';
import { api } from '@/lib/api';

export default function ExplorerPage(): import('react/jsx-runtime').JSX.Element {
  const { data } = useQuery({
    queryKey: ['projects'],
    queryFn: () => api.listProjects(),
    staleTime: 5 * 60 * 1000,
  });

  const projects = data?.projects ?? [];

  return (
    <div className="mx-auto max-w-[1600px] w-full px-6 md:px-8 py-8 space-y-8 animate-fade-in">
      {/* Header */}
      <div className="flex items-end justify-between">
        <div className="space-y-1">
          <div className="flex items-center gap-3 mb-2">
            <Link
              to="/"
              className="flex items-center gap-1.5 text-[11px] font-mono text-muted-foreground/50 hover:text-muted-foreground transition-colors"
            >
              <ArrowLeft className="h-3.5 w-3.5" />
              Anomaly Hub
            </Link>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg bg-blue-500/10 border border-blue-500/20 flex items-center justify-center">
              <Search className="h-4 w-4 text-blue-400" />
            </div>
            <div>
              <h1 className="text-2xl font-bold tracking-tight text-foreground">
                Execution Explorer
              </h1>
              <p className="text-sm text-muted-foreground/60">
                Search, filter, and investigate executions across{' '}
                <span className="font-mono text-foreground/80 px-1 bg-white/[0.03] rounded">
                  {projects.length} app{projects.length !== 1 ? 's' : ''}
                </span>
              </p>
            </div>
          </div>
        </div>

        <div className="hidden md:flex flex-col items-end gap-0.5 text-[10px] font-mono text-muted-foreground/30">
          <span>click filters below — no query syntax needed</span>
        </div>
      </div>

      <Suspense fallback={<div className="h-96 w-full animate-pulse bg-white/5 rounded-xl" />}>
        <ExecutionExplorer />
      </Suspense>
    </div>
  );
}
